import React, {useState} from 'react';
import { Box, Drawer, useTheme, useMediaQuery } from '@mui/material';
import { SideNavigation, SIDEBAR_WIDTH } from './SideNavigation';
import { AppHeader } from './AppHeader';
import { OpsSidebar } from '../ops/OpsSidebar';
import { useLocation } from 'react-router-dom';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const theme = useTheme();
  const location = useLocation();
  const isAboveMobile = useMediaQuery(theme.breakpoints.up('sm'));
  const [isHamburgerDrawerOpen, setHamburgerMenuOpen] = useState(false);
  const toggleIsHamburgerDrawerOpen = () => setHamburgerMenuOpen((prev) => !prev);

  const isOps = location.pathname.startsWith('/ops');

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Side Navigation */}

      {isAboveMobile ? (
        <SideNavigation fixed />
      ) : (
        <Drawer
          open={isHamburgerDrawerOpen}
          onClose={toggleIsHamburgerDrawerOpen}
        >
          { isOps ? <OpsSidebar /> : <SideNavigation /> }
        </Drawer>
      )}
      
      {/* Main Content Area */}
      <Box
        sx={{
          flex: 1,
          marginLeft: `${SIDEBAR_WIDTH}px`,
          [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
          },
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        {/* Updated Header */}
        <AppHeader onHamburgerMenuToggle={toggleIsHamburgerDrawerOpen} />
        
        {/* Page Content */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}
